"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedDrivers = getSupportedDrivers;
exports.getCurrentDriver = getCurrentDriver;
exports.getNextDriver = getNextDriver;
const state_flow_1 = require("@video/state-flow");
function isDriverState(state) {
    return typeof state === "object" && state !== null && "driverFormat" in state && "priority" in state;
}
function getSupportedDrivers(groups) {
    let current = "";
    const drivers = Object.keys(groups).reduce((acc, key) => {
        const group = groups[key];
        // walk through all the groups and collect the ones that are driver states
        // and are not marked as not supported
        if (!isDriverState(group)) {
            return acc;
        }
        switch ((0, state_flow_1.getStateName)(group)) {
            case "Prepared":
            case "Stopped":
                acc.push([key, group.priority]);
                break;
            case "InUse":
                acc.push([key, group.priority]);
                current = key;
        }
        return acc;
    }, []).sort((a, b) => b[1] - a[1]);
    // [drivers, index of current driver]
    const names = drivers.map(v => v[0]);
    return [names, names.indexOf(current)];
}
function getCurrentDriver(groups) {
    for (const key in groups) {
        const group = groups[key];
        if (isDriverState(group) && (0, state_flow_1.getStateName)(group) === "InUse") {
            return [key, group];
        }
    }
    return [
        null, {
            driverFormat: "", timeout: 0, priority: 0, support: "", features: {
                autoBitrate: false,
                forcedQuality: false,
                sourceQuality: false,
            },
        }
    ];
}
function getNextDriver(groups) {
    const [drivers, current] = getSupportedDrivers(groups);
    if (current === -1) {
        return null;
    }
    return drivers[(current + 1) % drivers.length];
}
//# sourceMappingURL=helpers.js.map